import type { Store } from 'redux';
import { IModuleStore } from 'redux-dynamic-modules-core';
import { ISagaModule } from 'redux-dynamic-modules-saga';
import { AemConfiguration } from '../AemConfigurationTypes';
import { DynamicReduxModuleRootInstance } from '../RenderTypes';
import { StoreEnhancerState } from './rootReducers';
import { History } from 'history';

export type ReduxStoreContext = {
  aemConfiguration: AemConfiguration;
};

export interface DynamicStoreInterface {
  getStore<T1>(): IModuleStore<T1>;

  setStore<T1>(store: IModuleStore<T1>): void;
}

export interface IStoreConfigurator {
  buildDynamic<S extends StoreEnhancerState, C extends ReduxStoreContext>(
    initialState: S,
    context: C,
    dynamicStore: DynamicStoreInterface,
    componentReduxModules: Array<ISagaModule<unknown>>,
    history?: History
  ): Store<StoreEnhancerState>;

  loadFromModuleCollection(
    componentName: string,
    initialState: StoreEnhancerState
  ): Promise<DynamicReduxModuleRootInstance>;
}
